module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "u-viewport-fit-w u-bg--black u-overflow-x-h",
    attrs: {
      "id": "app"
    }
  }, [(_vm.content !== null) ? _c('app-header', {
    class: [_vm.isFirstLoading ? 'is-first-loading' : '', 'is-routing-' + _vm.routingStep, _vm.$route.name !== 'page-home' && _vm.$route.name !== 'page-home-slide' ? 'is-small' : '']
  }) : _vm._e(), _vm._v(" "), _c('div', {
    class: [_vm.width < 770 || _vm.isTouch ? 'u-relative u-zindex--3' : 'u-fixed u-pos-tl u-viewport-fit-h u-viewport-fit-w u-overflow-h u-zindex--3']
  }, [_c('div', {
    staticClass: "js-container u-fit-w"
  }, [(_vm.content !== null) ? _c(_vm.componentId, {
    tag: "component",
    staticClass: "js-page page",
    class: ['' + _vm.componentId, _vm.isFirstLoading ? 'is-first-loading' : '', _vm.isFirstLoaded ? 'is-first-loaded' : '', 'is-routing-' + _vm.routingStep, _vm.isTouch ? 'is-touch' : ''],
    attrs: {
      "content": _vm.content,
      "params": _vm.params,
      "routing-step": _vm.routingStep,
      "is-first-loading": _vm.isFirstLoading,
      "is-first-loaded": _vm.isFirstLoaded
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('app-loader', {
    class: ['is-' + _vm.componentId, _vm.isTouch ? 'is-touch' : '', _vm.width < 770 ? 'is-mobile' : ''],
    attrs: {
      "is-active": _vm.isFirstLoading,
      "page": _vm.componentId
    }
  }), _vm._v(" "), _c('app-popin-email'), _vm._v(" "), _c('div', {
    staticClass: "u-fixed u-pos-tl u-zindex--2 u-viewport-fit u-overflow-h js-background"
  }), _vm._v(" "), _c('app-page-transition', {
    class: ['is-' + _vm.componentId, _vm.isTouch ? 'is-touch' : ''],
    attrs: {
      "routing-step": _vm.routingStep,
      "page": _vm.componentId
    }
  }), _vm._v(" "), (!_vm.isTouch) ? _c('app-sound-manager', {
    attrs: {
      "isMuted": _vm.isMuted
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$route.name !== 'page-home' && _vm.$route.name !== 'page-home-slide' && _vm.$root.width > 770 && !_vm.isTouch && (!_vm.isFirstLoading || _vm.routingStep !== 0)) ? _c('div', {
    staticClass: "js-fake-scroll-container",
    style: ({
      height: _vm.pageHeight + 'px'
    })
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b1ac88c8"}!./src/scripts/application/template.html
// module id = 479
// module chunks = 0